import { CCardFooter } from "@coreui/react";
import { Box, Button, Card, CardContent, CardHeader, Divider, IconButton, MenuItem, Select, SelectChangeEvent, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import {AttachFile, Delete} from '@mui/icons-material'
import { T_Inquery } from "../../common/model/InqueryModel";
import apis from "../../common/apis";
import { initialAlert, useAlert } from "../../provider/AlertContextProvider";
import { T_Code } from "../../common/model/codeModel";
import { T_Trouble } from "../../common/model/troubleModel";
export default function TroubleInsert(){
    const nav = useNavigate();
    const [cstatus ,setCstatus] = useState('0');
    const [data,setData] = useState<T_Trouble>({gubun:"자동운전",type:"수동운전"});
    const {alert,setAlert} = useAlert();
    const [typeList,setTypeList] = useState<T_Code[]>();
    const [gubunList,setGubunList] = useState<T_Code[]>();

    const handleChange = (event: SelectChangeEvent) => {
      setCstatus(event.target.value);
      };
      const [selectedFiles, setSelectedFiles] = useState<File[]>([])

      const handleFileChange = (
        event: React.ChangeEvent<HTMLInputElement>,
      ) => {
        if (!event.target.files) return
        setSelectedFiles(Array.from(event.target.files))
      }    

      const handleRemoveFile = (index: number) => {
        setSelectedFiles(prev =>
          prev.filter((_, i) => i !== index)
        )
      }

      const saveData = async()=>{

        if(data.contents == "" || data.contents === undefined){
            setAlert({...alert,visible:true,title:"확인",msg:"내용용을 입력하여 주십시요"})   
            return;
        }
         
        setAlert({...alert,title:"확인",msg:"정말로 등록 하시겠습니가?",visible:true,buttonList:[
            {
                text:"예"
                ,variant:"contained"
                ,onPress:async()=>{
                    const result = await apis.trouble.troubleCreate({...data,filelist:selectedFiles})   
                    console.log("result:",result);
                    if(result.code=="1"){
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"등록이 완료되었습니다."})
                        nav("/trouble")
                    }else{
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"등록중 오류가 발생했습니다.."})
                    }
           
                }
            },{
                text:"아니요"
                ,variant:"outlined"
                ,onPress:()=>{
                    setAlert(initialAlert);
                }
            }
        ]})


      }


   const getTypeList = async()=>{
      const result = await apis.code.codeList({pCode:"type"})
      console.log(result)
      if(result.code=="1"){
         setTypeList(result.data.list);
//         setData({...data,type:result.data.list[0].code})
      }
   }   
   const getGubunList = async()=>{
      const result = await apis.code.codeList({pCode:"gubun"})
      console.log(result)
      if(result.code=="1"){
         setGubunList(result.data.list);
//         setData({...data,type:result.data.list[0].code})
      }
   }   

   useEffect(()=>{
      getTypeList();
      getGubunList();
   },[])

    return(
    <>
    <Card >
        <CardHeader title="트러블슈팅 등록" sx={{pb:0,mb:0}}/>
        <CardContent>
            <Divider />
        <Table  stickyHeader aria-label="sticky table"  sx={{borderTopWidth:2
          }} > 
            <TableHead />
            <TableBody>
            <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          구분
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={data.gubun}
                            onChange={(event:SelectChangeEvent)=>{
                              setData({...data,gubun:event.target.value})
                            }}
                            size="small"
                        >
                           { gubunList && gubunList.map((item,idx)=>{
                              return(<MenuItem value={item.name}>{item.name}</MenuItem>)
                            })}
                        </Select>
                        </TableCell>      
                        <TableCell component="th" scope="row" sx={{width:150}}>
                          항목
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={data.type}
                            onChange={(event:SelectChangeEvent)=>{
                              setData({...data,type:event.target.value});
                            }}
                            size="small"
                        >
                            { typeList && typeList.map((item,idx)=>{
                              return(<MenuItem value={item.name}>{item.name}</MenuItem>)
                            })}
                        </Select>

                        </TableCell>                         

          </TableRow>        
        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          에러코드
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}} colSpan={3}>
                        <TextField  size="small" fullWidth value={data.errcode || ''} onChange={(event)=>{setData({...data,errcode:event.target.value})}} />
                        </TableCell>      

        </TableRow>          

        <TableRow>          
        <TableCell component="th" scope="row" sx={{width:150}}>
                          문의내용
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}} colSpan={3}>
                          <TextField multiline
                            rows={10}
                            fullWidth 
                            value={data.contents || ''} onChange={(event)=>{setData({...data,contents:event.target.value})}}
                          />
                        </TableCell>      

        </TableRow>          
        <TableRow>          
                        <TableCell component="th" scope="row" sx={{width:150}}>
                          처리방법
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}} colSpan={3}>
                          <TextField multiline
                            rows={10}
                            fullWidth 
                            value={data.pmethod || ''} onChange={(event)=>{setData({...data,pmethod:event.target.value})}}
                          />
                        </TableCell>      

        </TableRow>   
        {/* <TableRow>  
                       <TableCell component="th" scope="row" sx={{width:150}}>
                          비고
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}} colSpan={3}>
                          <TextField multiline
                            rows={10}
                            fullWidth 
                            value={data. || ''} onChange={(event)=>{setData({...data,contents:event.target.value})}}
                          />
                        </TableCell>      

        </TableRow>             */}
        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          파일첨부
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}} colSpan={3}>
                        <Button
                        variant="contained"
                        component="label"
                        startIcon={<AttachFile />}
                        >
                        파일 선택
                        <input
                            type="file"
                            hidden
                            multiple                        // 여러 파일 선택허용
                            onChange={handleFileChange}
                        />
                        </Button>

                        {/* 선택된 파일명 리스트 */}
                        {selectedFiles.length > 0 && (
                        <Box mt={1}>
                            {selectedFiles.map((file, idx) => (
                               <Box
                               key={idx}
                               sx={{
                                 display: 'flex',
                                 alignItems: 'center',
                                 mt: 0.5,
                               }}
                             >    
                            <Typography
                                variant="body2"
                                key={idx}
                            >
                                {file.name}
                            </Typography>
                            <IconButton
                            size="small"
                            onClick={() => handleRemoveFile(idx)}
                            >
                            <Delete fontSize="small" />
                            </IconButton>
                          </Box>
                            ))}
                        </Box>
                        )}                            
                        </TableCell>      

        </TableRow>        
        </TableBody>

        </Table>

        </CardContent>
        <CCardFooter style={{   display: 'flex',justifyContent:'center',textAlign:'center',paddingBottom:10, gap: '1rem'}}  >
        <Button variant="contained" onClick={()=>{
          saveData();
          }}>저장</Button>
        <Button variant="outlined" onClick={()=>{
        nav(-1);
         }}>취소</Button>

        </CCardFooter>
    </Card>

    </>)
}